export default "__VITE_ASSET__7d78ebbb__"